module.exports = __webpack_public_path__ + "static/media/SimplePromptHsbcLarge.077a9913.png";